// Scripted demonstration content for "Ask Oceanside". Uses approved/site-published facts only.
// No prices, dates, approvals, finance, legal or site-suitability advice.

export type AssistantLink = { label: string; to: string };
export type AssistantReply = { text: string; links: AssistantLink[] };
export type AssistantTopic = "design" | "process" | "block" | "consult" | "pricing" | "fallback";

export const assistantStarters: { id: AssistantTopic; label: string }[] = [
  { id: "design", label: "Find a design" },
  { id: "process", label: "Understand the process" },
  { id: "block", label: "Discuss a block" },
  { id: "consult", label: "Request a consultation" },
];

export const assistantReplies: Record<AssistantTopic, AssistantReply> = {
  design: {
    text: "Oceanside publishes four single-storey designs. For 10m frontages: The Solene (3 bed, separate theatre) and The Cortez (4 bed, walk-in pantry). For 15m frontages: The Azure (3 bed, front verandah) and The Hacienda (4 bed, 21m² alfresco). Every design can be tailored. A frontage category is a starting point, so it doesn't confirm a design fits your particular block.",
    links: [
      { label: "Browse home designs", to: "/home-designs" },
      { label: "View The Azure", to: "/home-designs/the-azure" },
    ],
  },
  process: {
    text: "There are ten stages: initial consultation, pre-con agreement, design and costing, working drawings, contract signing, selections, final plans, permits and approvals, construction and handover. The pre-con agreement sets out the scope and pre-construction costs before that work begins.",
    links: [{ label: "See our building process", to: "/our-process" }],
  },
  block: {
    text: "Whether a home suits a block depends on width, depth, orientation, setbacks, slope, easements and local planning rules. I can't assess a site, but the team can talk it through with you. Knock-down/rebuilds, rear blocks and developments are all services Oceanside offers.",
    links: [
      { label: "Talk to the team about your block", to: "/contact?project=unsure" },
      { label: "What we build", to: "/#services" },
    ],
  },
  consult: {
    text: "You can request a consultation using a short two-step form. It asks about your project and how you'd like to be contacted. A request isn't a confirmed appointment: the team will be in touch to discuss your plans and confirm a suitable time.",
    links: [{ label: "Request a consultation", to: "/contact" }],
  },
  pricing: {
    text: "I can't give prices. A build price depends on the design, your site, your selections and the agreed scope. The team can explain the steps towards project-specific costing.",
    links: [
      { label: "Pricing and inclusions explained", to: "/#inclusions" },
      { label: "Discuss pricing with the team", to: "/contact" },
    ],
  },
  fallback: {
    text: "That's outside what I can answer in this demonstration. The team is the best source: call 08 6285 0876 or email admin@oceansideliving.com.au.",
    links: [{ label: "Contact the team", to: "/contact" }],
  },
};
